import React from "react";

export const WhatsAppButton = ({ phone }) => {
  if (!phone) return null;
  const num = phone.replace(/[^0-9]/g, "");
  return (
    <a href={`https://wa.me/${num}`} target="_blank" rel="noreferrer"
      data-testid="whatsapp-float-btn" aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-[55] w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.35)] hover:scale-110 hover:bg-[#1fb457] transition-transform duration-300">
      <svg viewBox="0 0 24 24" className="w-7 h-7 fill-black">
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2Zm5.8 14.1c-.25.7-1.44 1.34-1.99 1.39-.55.05-1.06.25-3.6-.85-2.99-1.29-4.87-4.44-5.02-4.65-.15-.2-1.19-1.63-1.19-3.11 0-1.48.77-2.21 1.05-2.51.27-.3.6-.37.8-.37.2 0 .4 0 .58.01.19.01.44-.07.68.52.25.6.85 2.08.92 2.23.07.15.12.32.02.52-.1.2-.15.32-.3.5-.15.17-.31.39-.44.52-.15.15-.3.31-.13.61.17.3.77 1.27 1.65 2.06 1.13 1.01 2.08 1.32 2.38 1.47.3.15.47.13.65-.08.17-.2.75-.87.95-1.17.2-.3.4-.25.67-.15.27.1 1.72.81 2.02.96.3.15.5.22.57.35.08.12.08.72-.17 1.42Z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
